import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ToastModal from "views/components/ToastModal";
import { saveSelfieDetails } from "store/reducers/login/LoginSlice";

const LivePhotoAuthRedirectHandler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const leadId = useSelector(
      (state) => state.login.userSelfieDetailsDigitap?.leadId
    );

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getAadharDetails();
  }, []);

  const getAadharDetails = async () => {
    const result = await apiHandler({
      url: endpoint.FACEE_LIVENESS_FETCH_DATA + leadId,
      authToken: authToken,
      method:"POST",
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      dispatch(saveSelfieDetails(result.data));
      navigate("/journey/selfiePhoto");
    }
  };
  return (
    <>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </>
  );
};

export default LivePhotoAuthRedirectHandler;
